import Checkbox from './Checkbox.vue';
import Date from './Date.vue';
import Email from './Email.vue';
import Number from './Number.vue';
import Radio from './Radio.vue';
import Select from './Select.vue';
import Text from './Text.vue';
import Textarea from './Textarea.vue';

/**
 *  Exporting every input component so it can be
 *  used/added by the Input.vue component.
*/
export default {
    checkbox: Checkbox,
    date: Date,
    email: Email,
    number: Number,
    radio: Radio,
    select: Select,
    text: Text,
    textarea: Textarea,
};
